<template>
    <div class="ekipa px-5 text-sm">
        <div class="id-card">
            <a-circular-image :image="require('@/assets/urska.jpg')" float="none" class="photo urska" />
            <div>
                <h2 class="!mb-0 !mt-0">{{ $t('ekipa.urska.name') }}</h2>
                <p class="mt-0">{{ $t('ekipa.urska.title') }}</p>
                <delimiter class="delimiter my-3 opacity-50" />
                <img src="@/assets/svg/quotes.svg" alt="" class="quotes-icon float-left mr-2" />
                <p class="text-blue-gray-300 italic">
                    {{ $t('ekipa.urska.quote') }}
                </p>
            </div>
        </div>
        <div class="id-card">
            <a-circular-image
                class="photo katja"
                :image="require('@/assets/photos/katja.jpg')"
                float="none"
            />
            <div>
                <h2 class="!mb-0 !mt-0">{{ $t('ekipa.katja.name') }}</h2>
                <p class="mt-0">{{ $t('ekipa.katja.title') }}</p>
                <delimiter class="delimiter my-3 opacity-50" />
                <img src="@/assets/svg/quotes.svg" alt="" class="quotes-icon float-left mr-2" />
                <p class="text-blue-gray-300 italic">
                    {{ $t('ekipa.katja.quote') }}
                </p>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts"></script>

<style scoped lang="scss">
.ekipa {
    display: flex;
    gap: 3rem;
    max-width: 650px;
    width: 100vw;
    text-align: left;
    overflow: hidden;
}

h2 {
    font-weight: bold;
}

.id-card {
    flex-basis: 50%;

    p {
        display: block;
    }
}

.quotes-icon {
    width: 1.2rem;
}

.delimiter {
    width: auto;
    opacity: 0.3;
}

.photo {
    margin: 0;
    margin-bottom: 1rem;
    justify-self: center;
    max-width: 180px;
    max-height: 180px;
}

@media only screen and (max-width: theme('screens.sm')) {
    .ekipa {
        flex-direction: column;
        padding-right: 3rem;
    }

    .id-card {
        display: flex;
        gap: 1rem;
    }

    .delimiter {
        opacity: 0.2;
    }

    .photo {
        flex-shrink: 0;
        max-width: 95px;
        max-height: 95px;
        margin: 0 !important;
    }
}
</style>
